/**
 * Scratch VM ile extension'lar arasında köprü görevi gören sınıf
 * Bu sınıf, Scratch VM ile extension'lar arasındaki iletişimi sağlar
 */

class VMExtensionBridge {
    /**
     * Extension köprüsünü oluşturur
     * @param {object} vm - Scratch VM örneği
     */
    constructor(vm) {
        this.vm = vm;
        this.serialExtension = null;
        this.serialHelper = null;
    }

    /**
     * Serial extension'ı ayarlar
     * @param {object} extension - Serial extension örneği
     * @param {object} helper - Serial helper örneği
     */
    setSerialExtension(extension, helper) {
        this.serialExtension = extension;
        this.serialHelper = helper;

        // Veri alındığında extension'a ilet
        this.serialHelper.onData = data => {
            if (this.serialExtension) {
                this.serialExtension.onData(data);
            }
        };

        // Bağlantı durumu değiştiğinde extension'a ilet
        this.serialHelper.onConnectionChanged = connected => {
            if (this.serialExtension) {
                this.serialExtension.updateConnectionState(connected);
            }
        };

        // VM üzerinden gelen mesajları dinle
        this.vm.on('SERIAL_SEND', data => {
            if (this.serialHelper && this.serialHelper.isConnected()) {
                this.serialHelper.sendData(data.data);
            }
        });
    }

    /**
     * Serial bağlantısını başlatır
     * @param {number} baudRate - Baud rate değeri
     * @returns {Promise<boolean>} Bağlantı durumu
     */
    async connectSerial(baudRate) {
        if (!this.serialHelper) {
            console.error('Serial helper henüz ayarlanmamış');
            return false;
        }

        try {
            const result = await this.serialHelper.connect(baudRate);
            return result;
        } catch (error) {
            console.error('Serial bağlantı hatası:', error);
            return false;
        }
    }

    /**
     * Serial bağlantısını keser
     */
    disconnectSerial() {
        if (this.serialHelper) {
            this.serialHelper.disconnect();
        }
    }

    /**
     * Web Serial API desteğini kontrol eder
     * @returns {boolean} Destek varsa true
     */
    isSerialSupported() {
        return this.serialHelper ? this.serialHelper.isSupported() : false;
    }
}

export default VMExtensionBridge; 